const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 769,
  DESKTOP: 1024,
  WIDESCREEN: 1216,
  FULL_HD: 1408,
};

export const RESPONSIVE = {
  MOBILE: `(max-width: ${BREAKPOINTS.TABLET - 1}px)`,
  TABLET: `(min-width: ${BREAKPOINTS.TABLET}px)`,
  TABLET_ONLY: `(min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${
    BREAKPOINTS.DESKTOP - 1
  }px)`,
  TOUCH: `(max-width: ${BREAKPOINTS.DESKTOP - 1}px)`,
  DESKTOP: `(min-width: ${BREAKPOINTS.DESKTOP}px)`,
  DESKTOP_ONLY: `(min-width: ${BREAKPOINTS.DESKTOP}px) and (max-width: ${
    BREAKPOINTS.WIDESCREEN - 1
  }px)`,
  UNTIL_WIDESCREEN: `(max-width: ${BREAKPOINTS.WIDESCREEN - 1}px)`,
  WIDESCREEN: `(min-width: ${BREAKPOINTS.WIDESCREEN}px)`,
  WIDESCREEN_ONLY: `(min-width: ${BREAKPOINTS.WIDESCREEN}px) and (max-width: ${
    BREAKPOINTS.FULL_HD - 1
  }px)`,
  UNTIL_FULL_HD: `(max-width: ${BREAKPOINTS.FULL_HD - 1}px)`,
  FULL_HD: `(min-width: ${BREAKPOINTS.FULL_HD}px)`,
};
